import React, { useEffect, useState, useRef } from 'react'
import { useTheme, useMediaQuery, Container, Box, List, Divider, ListItemText, ListItem, ListItemButton, ListItemIcon, Grid, Chip, Alert, AlertTitle, Typography, IconButton } from '@mui/material'
import ReactMarkdown from 'react-markdown'
import { db } from '../firebase.js'
import { collection, query, where, doc, onSnapshot, updateDoc, getDocs } from 'firebase/firestore'
import { useLocation } from 'react-router-dom'
import ChatMessage from '../components/ChatMessage'
import DialogSlide from '../components/DialogSlide'
// import MailIcon from '@mui/icons-material/Mail'
import StartIcon from '@mui/icons-material/Start'
import { SkipNext } from '@mui/icons-material'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious'
import AlertDialog from '../components/AlertDialog.js'

function AdminPage () {
  // Themeing
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTabletorMobile = useMediaQuery(theme.breakpoints.down('md'))
  const pageStyle = {
    page: { height: isMobile ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)', display: 'flex', flexDirection: 'row', justifyContent: 'center' },
    content: { height: isMobile ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    infoContainer: { maxWidth: '820px', width: '22%', height: '100%', display: 'flex', flexDirection: 'column', mr: '3px' },
    sidebarContainer: { marginTop: '2px', backgroundColor: '#F7F9F9', display: isTabletorMobile ? 'none' : 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)' },
    messagesContainer: { maxWidth: '820px', width: '78%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', overflow: 'auto' },
    messageList: { m: '0px 3px 0px 3px', overflow: 'auto' }
  }

  const location = useLocation()
  const gameId = location.state?.gameId
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false)
  const [isPreviousDialogOpen, setIsPreviousDialogOpen] = useState(false)
  const [isChoseQuestDialogOpen, setIsChoseQuestDialogOpen] = useState(false)
  const [isEvalDialogOpen, setIsEvalDialogOpen] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [messages, setMessages] = useState([])
  const [summaries, setSummaries] = useState([])
  const [quests, setQuests] = useState([])
  const [turn, setTurn] = useState(0)
  const [selectedTurn, setSelectedTurn] = useState(0)
  const lastTurn = quests.length
  // eslint-disable-next-line no-unused-vars
  const [blockSend, setBlockSend] = useState(false)
  const [pendingTurn, setPendingTurn] = useState(null)

  const messagesEndRef = useRef()

  useEffect(() => {
    const fetchQuests = async () => {
      const questsDocs = []
      const questSnap = await getDocs(collection(db, 'quests'))
      questSnap.forEach((quest) =>
        questsDocs.push(
          { id: quest.id, ...quest.data(), type: 'quest' }
        ))
      questsDocs.sort((a, b) => a.turn - b.turn)
      setQuests(questsDocs)
    }

    const gameRef = doc(db, 'games', gameId)

    const gameUnsubcribe = onSnapshot(gameRef, (doc) => {
      if (doc.exists()) {
        setTurn(doc.data().turn)
      } else {
        console.log('No such document!')
      }
    }, (error) => {
      console.log('Error listening to document: ', error)
    })

    const messagesQuery = query(
      collection(db, 'messages'),
      where('gameId', '==', gameId)
    )
    const messagesUnsubscribe = onSnapshot(messagesQuery, (querySnapshot) => {
      const messagesDocs = []
      querySnapshot.forEach((doc) => {
        messagesDocs.push({
          ...doc.data()
        })
      })
      messagesDocs.sort((a, b) => a.createdAt - b.createdAt)
      setMessages(messagesDocs)
    })

    const summariesQuery = query(
      collection(db, 'horizontal'),
      where('gameId', '==', gameId))

    const summariesUnsubscribe = onSnapshot(summariesQuery,
      (querySnapshot) => {
        const summariesDocs = []
        querySnapshot.forEach((doc) => {
          summariesDocs.push({
            ...doc.data(), type: 'sum'
          })
          setSummaries(summariesDocs)
        }
        )
      })

    fetchQuests()
    // clean up
    return () => {
      summariesUnsubscribe()
      messagesUnsubscribe()
      gameUnsubcribe()
    }
  }, [])

  useEffect(() => {
    setBlockSend(summaries.some(item => item.turn === turn))
  }, [summaries, turn])

  // scrolls to bottom after render
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'instant' })
  }, [messages])

  // const lockUserScreens = async () => {
  //   try {
  //     const docRef = doc(db, 'games', gameId)
  //     await updateDoc(docRef, {
  //       isLocked: true
  //     })
  //     await updateDoc(docRef, {
  //       isLocked: false
  //     })
  //   } catch (error) {
  //     console.error('Error locking User Screens:', error)
  //   }
  // }

  const updateGameTurn = async (num) => {
    try {
      const gameRef = doc(db, 'games', gameId)
      await updateDoc(gameRef, {
        turn: num
      })
      setIsChoseQuestDialogOpen(false)
    } catch (error) {
      console.error('Error updating turn:', error)
    }
  }

  const decrementTurn = async (num) => {
    try {
      const gameRef = doc(db, 'games', gameId)
      await updateDoc(gameRef, {
        turn: turn - num
      })
    } catch (error) {
      console.error('Error updating turn')
    }
  }

  const incrementTurn = async (num) => {
    try {
      const gameRef = doc(db, 'games', gameId)
      await updateDoc(gameRef, {
        turn: turn + num
      })
    } catch (error) {
      console.error('Error updating turn')
    }
  }

  const triggerEvaluation = async () => {
    setIsFetching(true)
    const apiRequestBody = {
      gameId,
      quest_id: quests.find(quest => quest.turn === turn).id,
      turn
    }

    try {
      const response = await fetch('https://task-somalia-688160029673.europe-west10.run.app/horizontal', {
        method: 'POST', // Specifying the method as POST
        headers: {
          'Content-Type': 'application/json' // Setting the content type header
        },
        body: JSON.stringify(apiRequestBody) // Converting the data to a JSON string for the request body
      })

      if (!response.ok) { // Checking if the status code is not 200
        setIsFetching(false)
        throw new Error('Request failed with status ' + response.status)
      }
      console.log(response)
      setIsFetching(false) // This function is called upon successful response
    } catch (error) {
      console.error('Error:', error)
      alert('There has been an errror generating the evaluation. Please try again in a few seconds')
      setIsFetching(false)
    }
  }

  return (
    <Grid container>
    <Grid item md={3} sx={ pageStyle.sidebarContainer}>
        <ListItemText sx={{ pt: 1 }} primary={(turn === 0) ? 'Game not started' : (turn !== lastTurn + 1) ? `Current Turn: Quest ${turn}` : 'Game has been ended'} primaryTypographyProps={{ align: 'center', variant: 'subtitle1' }}></ListItemText>
        <Divider></Divider>
        <Box sx={{ overflow: 'auto', backgroundColor: '#F7F9F9', height: '100%' }}>
          <List>
            {quests.map((quest, index) => (
              <ListItem
                      key={quest.turn}
                      disablePadding
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={(() => {
                          setPendingTurn(quest.turn)
                          setIsChoseQuestDialogOpen(true)
                        })}>
                          <SkipNext />
                        </IconButton>
                      }
                    >
                      <ListItemButton
                        onClick={() => setSelectedTurn(quest.turn) }
                        selected={selectedTurn === quest.turn}
                      >
                        <ListItemIcon>
                          <Chip label={quest.turn} />
                        </ListItemIcon>
                        <ListItemText
                          primary={quest.theme}
                          secondary={turn === quest.turn ? ' Currently playing' : null}
                          secondaryTypographyProps={{ style: { color: '#CD5C5C' } }}
                        />
                      </ListItemButton>
                    </ListItem>
            ))}
          </List>
          <Divider />
          <List>
            <ListItem key={'Previous Quest'} disablePadding>
              <ListItemButton onClick={() => { setIsPreviousDialogOpen(true) }}>
                <ListItemIcon>
                  <SkipPreviousIcon />
                </ListItemIcon>
                <ListItemText primary={'Previous Quest'} />
              </ListItemButton>
            </ListItem>
            <ListItem key={'Begin next Quest'} disablePadding>
              <ListItemButton disabled={ turn >= lastTurn + 1 } onClick={() => { setIsAlertDialogOpen(true) }}>
                <ListItemIcon>
                  <StartIcon></StartIcon>
                </ListItemIcon>
                <ListItemText primary={(turn === 0) ? 'Start Game' : (turn >= lastTurn) ? 'End Game' : 'Start Next Quest'} />
              </ListItemButton>
            </ListItem>
            <ListItem key={'Evaluate Answers'} disablePadding>
              <ListItemButton disabled={ turn >= lastTurn + 1 || turn === 0 || isFetching || blockSend
               } onClick={() => { setIsEvalDialogOpen(true) }}>
                <ListItemIcon>
                  <QuestionAnswerIcon />
                </ListItemIcon>
                <ListItemText primary={'Evaluate Answers'} />
              </ListItemButton>
            </ListItem>
            {/* <ListItem sx={{ display: 'none' }} key={'Show Info to Player'} disablePadding>
              <ListItemButton onClick={() => { lockUserScreens() }}>
                <ListItemIcon>
                  <MailIcon />
                </ListItemIcon>
                <ListItemText primary={'Lock User Screens'} />
              </ListItemButton>
            </ListItem> */}
          </List>
        </Box>
    </Grid>
    <Grid item xs={12} md={9} >
      {isTabletorMobile &&
          <DialogSlide>
            <ListItemText sx={{ pt: 1 }} primary={(turn === 0) ? 'Game not started' : (turn !== lastTurn + 1) ? `Current Turn: Quest ${turn}` : 'Game has been ended'} primaryTypographyProps={{ align: 'center', variant: 'subtitle1' }}></ListItemText>
        <Divider></Divider>
        <Box sx={{ overflow: 'auto', backgroundColor: '#F7F9F9', height: '100%' }}>
          <List>
            {quests.map((quest, index) => (
              <ListItem
                      key={quest.turn}
                      disablePadding
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={(() => {
                          setPendingTurn(quest.turn)
                          setIsChoseQuestDialogOpen(true)
                        })}>
                          <SkipNext />
                        </IconButton>
                      }
                    >
                      <ListItemButton
                        onClick={() => setSelectedTurn(quest.turn) }
                        selected={selectedTurn === quest.turn}
                      >
                        <ListItemIcon>
                          <Chip label={quest.turn} />
                        </ListItemIcon>
                        <ListItemText
                          primary={quest.theme}
                          secondary={turn === quest.turn ? ' Currently playing' : null}
                          secondaryTypographyProps={{ style: { color: '#CD5C5C' } }}
                        />
                      </ListItemButton>
                    </ListItem>
            ))}
          </List>
          <Divider />
          <List>
              <ListItem key={'Previous Quest'} disablePadding>
              <ListItemButton onClick={() => { setIsPreviousDialogOpen(true) }}>
                <ListItemIcon>
                  <SkipPreviousIcon />
                </ListItemIcon>
                <ListItemText primary={'Previous Quest'} />
              </ListItemButton>
            </ListItem>
            <ListItem key={'Begin next Quest'} disablePadding>
              <ListItemButton disabled={ turn >= lastTurn + 1 } onClick={() => { setIsAlertDialogOpen(true) }}>
                <ListItemIcon>
                  <StartIcon></StartIcon>
                </ListItemIcon>
                <ListItemText primary={(turn === 0) ? 'Start Game' : (turn >= lastTurn) ? 'End Game' : 'Start Next Quest'} />
              </ListItemButton>
            </ListItem>
            <ListItem key={'Evaluate Answers'} disablePadding>
              <ListItemButton disabled={ turn >= lastTurn + 1 || turn === 0 || isFetching || blockSend
               } onClick={() => { setIsEvalDialogOpen(true) }}>
                <ListItemIcon>
                  <QuestionAnswerIcon />
                </ListItemIcon>
                <ListItemText primary={'Evaluate Answers'} />
              </ListItemButton>
            </ListItem>
            {/* <ListItem sx={{ display: 'none' }} key={'Show Info to Player'} disablePadding>
              <ListItemButton onClick={() => { lockUserScreens() }}>
                <ListItemIcon>
                  <MailIcon />
                </ListItemIcon>
                <ListItemText primary={'Lock User Screens'} />
              </ListItemButton>
            </ListItem> */}
          </List>
        </Box>
          </DialogSlide>}
    <Container sx={ pageStyle.content }>
      <Box sx={pageStyle.messagesContainer }>
        <List sx={ pageStyle.messageList }>
              {messages.filter((message) => message.turn === selectedTurn)
                .map((message, index) =>
                <ChatMessage key={index} uniqueId={index} content={message.content} role={message.role} playerName={message.playerName} secondaryText={message.playerName} messageType={message.type}/>)}
              {summaries.filter((summary) => summary.turn === selectedTurn)
                .map((summary, index) => {
                  return (
                  <Alert key={'Summary'} variant='outlined' icon={false} severity='info' sx={{ mb: '5px' }}>
                  <AlertTitle> Horizontal Evaluation </AlertTitle>
                    <Typography component="div">
                      <ReactMarkdown>
                        {summary.content}
                      </ReactMarkdown>
                    </Typography>
                  </Alert>)
                }
                )}
              <div ref={ messagesEndRef }></div>
            </List>
      </Box>
    </Container>
    </Grid>
    <AlertDialog isOpen={isAlertDialogOpen} handleClose={() => { setIsAlertDialogOpen(false) }} handleAgree={() => { incrementTurn(1) }} dialogTitle={ (turn >= lastTurn) ? 'End the Game?' : 'Start the next Quest?' } dialogContent={ (turn >= lastTurn) ? 'This will end the game for all players' : 'Are you sure you want to go back to the previous quest?'}></AlertDialog>
    <AlertDialog isOpen={isPreviousDialogOpen} handleClose={() => { setIsPreviousDialogOpen(false) }} handleAgree={() => { decrementTurn(1) }} dialogTitle={ 'Previous Quest?' } dialogContent={ 'Are you sure you want to go back to the previous quest? '}></AlertDialog>
    <AlertDialog
      isOpen={isChoseQuestDialogOpen}
      handleClose={() => { setIsChoseQuestDialogOpen(false) }}
      handleAgree={() => { updateGameTurn(pendingTurn) }}
      dialogTitle={'Start this Quest?'}
      dialogContent={`Are you sure you want to start Quest Number ${pendingTurn}?`}
/>    <AlertDialog isOpen={isEvalDialogOpen} handleClose={() => { setIsEvalDialogOpen(false) }} handleAgree={() => { triggerEvaluation() }} dialogTitle={ 'Compare User Repsonses?' } dialogContent={ 'Do you want to analyse the user responses of the current Quest? This will display the evaluation to the user.'}></AlertDialog>
  </Grid>
  )
}

export default AdminPage
